<template>
  <div>
    <div class="row">
      <PublicHeader title="Dívida Ativa">
        <div class="col-xs-12 col-sm-8 col-lg-6">
          <p>
            Aqui você encontra a lista de devedores cadastrados junto à Dívida
            Ativa do Município de Santos.
          </p>
          <p>
            Você pode efetuar a consulta por página, ou digitando um nome para a
            busca.
          </p>
          <p>
            O quadro indicará o nome do contribuínte bem como a origem e o valor
            da dívida.
          </p>
        </div>
      </PublicHeader>
    </div>
    <div class="row">
      <main class="container">
        <Breadcrumb :links="[{ label: 'Dívida Ativa' }]" />
        <div class="row margem-bottom">
          <div class="col-xs-12">
            <h3>
              Lista de Devedores
            </h3>
            <button
              class="btn btn-default"
              @click="downloadPaginaDividaAtiva()"
            >
              <font-awesome-icon :icon="'file-download'" /> Exportar para CSV
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12">
            <label for="filtro">Filtrar por nome</label>
            <div class="input-group">
              <input
                type="text"
                id="filtro"
                v-model="nome"
                class="form-control"
                @keyup.enter="filterByName()"
              />
              <span class="input-group-btn">
                <button
                  type="button"
                  class="btn btn-default"
                  @click="filterByName()"
                >
                  <font-awesome-icon :icon="'search'" />
                  <span class="sr-only">Filtrar nome</span>
                </button>
              </span>
            </div>
          </div>
        </div>
        <div class="row" v-if="loading">
          <div class="col-xs-12 text-center loading">
            Carregando <font-awesome-icon :icon="'spinner'" spin />
          </div>
        </div>
        <div v-else>
          <div v-if="total === 0">
            <div class="col-xs-12 text-center loading">
              Nenhum item encontrado!
            </div>
          </div>
          <div v-else>
            <Paginacao :total="total" v-model="page" />
            <div class="row linha-header">
              <div class="col-xs-12 col-sm-5">
                <span>Contribuinte</span>
              </div>
              <div class="col-xs-12 col-sm-5">
                <span>Cobrança</span>
              </div>
              <div class="col-xs-12 col-sm-2 text-right">
                <span>Valor da Dívida</span>
              </div>
            </div>
            <div
              v-for="(devedor, index) in devedores"
              :key="`${index}-devedor`"
              :class="['row linha', index % 2 === 0 ? 'even' : '']"
            >
              <div class="col-xs-12 col-sm-5">
                {{ devedor.NMCONTRIBUINTE }}
              </div>
              <div class="col-xs-12 col-sm-5">
                {{ devedor.QTDIVIDA }} dívida(s) de "{{ devedor.DLCOBRANCA }}"
              </div>
              <div class="col-xs-12 col-sm-2 text-right">
                {{ formatarMoeda(devedor.VLACUMULADO) }}
              </div>
            </div>
            <Paginacao :total="total" v-model="page" />
          </div>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import { PublicHeader, Breadcrumb } from '../../../components'
import Paginacao from '../../../components/DividaAtiva/Paginacao.vue'
import { request } from '../../../request'
import { formatarMoeda, exportCSVFile } from '../../../utils'

export default {
  components: {
    PublicHeader,
    Breadcrumb,
    Paginacao
  },
  data() {
    return {
      devedores: [],
      nome: '',
      loading: false,
      total: 0,
      page: 1,
      filter: '',
      lastFilter: ''
    }
  },
  mounted() {
    this.fetchDividaAtiva()
  },
  watch: {
    page() {
      this.fetchDividaAtiva()
    }
  },
  methods: {
    formatarMoeda,
    toggleLoading() {
      this.loading = !this.loading
    },
    filterByName() {
      this.filter = this.nome

      if (this.page === 1) {
        this.fetchDividaAtiva()
        return
      }

      this.page = 1
    },
    fetchDividaAtiva() {
      this.toggleLoading()

      request
        .get('lista-divida-ativa', {
          params: {
            start: (this.page - 1) * 100,
            total: 100,
            name: this.filter ? this.filter : null
          }
        })
        .then(response => {
          this.devedores = response.data[0]
          this.total = response.data[1]
        })
        .catch(error => {
          console.log(error.response)
          this.$toastr.e(
            'Houve um erro ao carregar a listagem da dívida ativa. Tente novamente mais tarde.'
          )
        })
        .finally(() => {
          this.toggleLoading()
        })
    },
    downloadPaginaDividaAtiva() {
      const headers = {
        NMCONTRIBUINTE: 'Contribuinte',
        DLCOBRANCA: 'Cobrança',
        QTDIVIDA: 'Qtde.Dívidas',
        VLACUMULADO: 'Valor da Dívida'
      }

      exportCSVFile(
        headers,
        [
          ...this.devedores.map(item => {
            return {
              NMCONTRIBUINTE: item.NMCONTRIBUINTE,
              DLCOBRANCA: item.DLCOBRANCA,
              QTDIVIDA: item.QTDIVIDA,
              VLACUMULADO: item.VLACUMULADO
            }
          })
        ],
        'divida-ativa'
      )
    }
  }
}
</script>

<style scoped>
.even {
  background-color: #e1e1e1;
}

.input-group-btn > button {
  border: 1px solid #468c36;
}

.linha {
  padding-top: 15px;
  padding-bottom: 15px;
}

.loading {
  font-size: 2rem;
  padding: 15px 0px;
}

.linha-header span {
  display: inline-block;
  font-weight: 600;
  font-size: 1.6rem;
  padding-top: 10px;
  padding-bottom: 10px;
}

@media only screen and (max-width: 768px) {
  .linha-header span {
    padding-top: 0px;
    padding-bottom: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/public/divida_ativa/index.vue